import { css } from 'styled-components';
import { getOverrideBackground } from '../../../utils/utilityFunction';
var background;
var styles = css(["", ";.textCard{padding:0 20px;text-align:center;.textCardContent{display:inline-block;margin-bottom:20px;ul{li{display:block;p{display:list-item;list-style-type:'\u2022  ';list-style-position:inside;}}}ol{li{display:block;p{display:list-item;list-style-position:inside;}}}}.heading_class{margin-bottom:10px;}.subheading_class{margin-bottom:20px;}.para_class{p{margin-bottom:40px;}}}"], function (props) {
  var _props$theme, _props$theme$imageSli, _props$theme3;
  var overrideBackground = props.overrideBackground;
  var backgroundColor = '';
  if (!(overrideBackground !== null && overrideBackground !== void 0 && overrideBackground.colorVariable) && (_props$theme = props.theme) !== null && _props$theme !== void 0 && (_props$theme$imageSli = _props$theme.imageSlider) !== null && _props$theme$imageSli !== void 0 && _props$theme$imageSli.primaryBgColor) {
    var _props$theme2, _props$theme2$imageSl;
    backgroundColor = "var(--sc-image-slider--primary-bg-color, ".concat((_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : (_props$theme2$imageSl = _props$theme2.imageSlider) === null || _props$theme2$imageSl === void 0 ? void 0 : _props$theme2$imageSl.primaryBgColor, ")");
  }
  /* See ImageSlider.style.js note */
  var restrictedOverrideBg = {
    colorVariable: overrideBackground === null || overrideBackground === void 0 ? void 0 : overrideBackground.colorVariable,
    backgroundId: overrideBackground === null || overrideBackground === void 0 ? void 0 : overrideBackground.backgroundId
  };
  background = getOverrideBackground({
    entry: restrictedOverrideBg,
    bgColor: backgroundColor,
    colorPalette: (_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.palette,
    debug: true
  });
  return background.css;
});
export default styles;